import {jwtDecrypt} from "/src/shared/helper";
import jwtInterceptor from "@/shared/jwtInterceptor";
const visitorMenus = [
  {
    title : 'کاربران',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/User/Add'},
      {title : 'لیست',icon : 'circle',href :'/User/List'},
    ],
  },
  {
    title : 'تغییر کلمه عبور',icon : 'tag',href: '/changePassword',active: false,
  },
  {
    title : 'خروج',icon : 'tag',href: '/Logout',active: false,
  }
];
const visitorRoutes = ['/','/User/Add','/User/List','/changePassword','/Logout'
];
const admin_menus = [
  {
    title : 'برند محصولات',icon : 'tag',href :'',active : false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/ProductBrand/Add'},
      {title : 'لیست',icon : 'circle',href :'/ProductBrand/List'},
    ],
  },
  {
    title : 'مرکز کنترل',icon : 'tag',href: '/OperationsCenter',active: false
  },
  {
    title : 'ویژگی های محصولات',icon : 'tag',href: '/ProductAttribute/Manage',active: false
  },
  {
    title : 'مدیریت اشتراک ها',icon : 'tag',href: '',
    children : [
      {title : 'افزودن',icon : 'circle',href :'/Plan/Add'},
      {title : 'لیست',icon : 'circle',href :'/Plan/List'},
    ],
  },
  {
    title : 'مدیریت انواع پرداخت',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/PaymentType/Add'},
      {title : 'لیست',icon : 'circle',href :'/PaymentType/List'},
    ],
  },
  {
    title : 'مدیریت اصناف',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/Guild/Add'},
      {title : 'لیست',icon : 'circle',href :'/Guild/List'},
    ],
  },
  {
    title : 'دسته بندی محصولات',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/ProductCategory/Add'},
      {title : 'لیست',icon : 'circle',href :'/ProductCategory/List'},
    ],
  },
  {
    title : 'محصولات',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/Product/Add'},
      {title : 'لیست',icon : 'circle',href :'/Product/List'},
    ],
  },
  {
    title : 'دلایل کنسل کردن معامله ',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/cancelTransactionReason/Add'},
      {title : 'لیست',icon : 'circle',href :'/cancelTransactionReason/List'},
    ],
  },
  {
    title : 'دلایل رد پیشنهاد ',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/rejectOfferReason/Add'},
      {title : 'لیست',icon : 'circle',href :'/rejectOfferReason/List'},
    ],
  },
  {
    title : 'کاربران',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/User/Add'},
      {title : 'لیست',icon : 'circle',href :'/User/List'},
    ],
  },
  {
    title : 'دپارتمان تیکت',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/ticketDepartment/Add'},
      {title : 'لیست',icon : 'circle',href :'/ticketDepartment/list'},
    ],
  },
  {
    title : 'پیام ها',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/UserMessage/Add'},
      {title : 'لیست',icon : 'circle',href :'/UserMessage/List'},
    ],
  },
  {
    title : 'تیکت ها',icon : 'tag',href: '/Ticket/List',active: false,
  },
  {
    title : 'درخواست های ثبت برند',icon : 'tag',href: '/RequestRegisterBrand/List',active: false,
  },
  {
    title : 'درخواست های ثبت محصول',icon : 'tag',href: '/RequestRegisterProduct/List',active: false,
  },
  {
    title : 'درخواست های بازار',icon : 'tag',href: '/MarketRequest/List',active: false,
  },
  {
    title : 'درخواست های مزایده',icon : 'tag',href: '/AuctionRequest/List',active: false,
  },
  {
    title : 'مدیران',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/Manager/Add'},
      {title : 'لیست',icon : 'circle',href :'/Manager/List'},
    ],
  },
  {
    title : 'درخواست های کاربر ویژه',icon : 'sparkles',href: '/RequestSpecialAccount/List',active: false,
  },
  {
    title : 'ویژگی محصولات بازار',icon : 'tag',href: '',active: false,
    children : [
      {title : 'افزودن',icon : 'circle',href :'/MarketProductAttr/Add'},
      {title : 'لیست',icon : 'circle',href :'/MarketProductAttr/List'},
    ],
  },
  {
    title : 'تنظیمات',icon : 'cogs',href: '',active: false,
    children : [
      {title : 'صفحه راهنما',icon : 'circle',href :'/setting/learningPage'},
      {title : ' مودال قوانین و مقررات',icon : 'circle',href :'/setting/lawModal'},
      {title : 'قیمت سکه ها و نردبان',icon : 'circle',href :'/setting/coinCost'},
    ],
  },
  {
    title : 'تنظیمات اکسپلور',icon : 'tag',href: '/Explore/FirstPageConfig',active: false,
  },
  {
    title : 'تنظیمات منو اکسپلور',icon : 'tag',href: '/Explore/configMenu',active: false,
  },
  {
    title : 'تراکنش های بانکی',icon : 'tag',href: '/bankTransactions/List',active: false,
  },
  {
    title : 'چندرسانه ای',icon : 'file',href: '/FileManager',active: false,
  },
  {
    title : 'تغییر کلمه عبور',icon : 'tag',href: '/changePassword',active: false,
  },
  {
    title : 'خروج',icon : 'tag',href: '/Logout',active: false,
  },
];
const adminRoutes = ['/','/ProductBrand/Add','/ProductBrand/List','/OperationsCenter','/ProductAttribute/Manage','/Plan/Add','/Plan/List',
  '/PaymentType/Add','/PaymentType/List','/Guild/Add','/Guild/List','/ProductCategory/Add','/ProductCategory/List',
  '/Product/Add','/Product/List','/cancelTransactionReason/Add','/cancelTransactionReason/List','/rejectOfferReason/Add',
  '/rejectOfferReason/List','/User/Add','/User/List','/ticketDepartment/Add','/ticketDepartment/list',
  '/UserMessage/Add','/UserMessage/List','/Ticket/List','/RequestRegisterBrand/List','/RequestRegisterProduct/List','/MarketRequest/List',
  '/AuctionRequest/List','/Manager/Add','/Manager/List','/setting/learningPage','/setting/lawModal','/setting/coinCost','/bankTransactions/List','/changePassword','/Logout'];

const state = () => ({
  authData: {
    token: "",
    refreshToken: "",
    tokenExp: "",
    userId: "",
    userName: "",
  },
  loginStatus: 'success',
  user: null,
  userMenus : [],
  userRoutes : [],
});

const mutations = {
  removeAuthToken(state)
  {
    state.authData = {
      token: "",
      refreshToken: "",
      tokenExp: "",
      userId: "",
      userName: "",
    }
  },
  saveAuthToken(state, payload)
  {

    const jwtDecodeUserInfo = jwtDecrypt(payload.access_token);
    state.authData = {
      token: payload.access_token,
      refreshToken: payload.refresh_token,
      userId: jwtDecodeUserInfo.user_id,
    };
  },
  saveLoginStatus(state, status)
  {
    state.loginStatus = status;
  },
  saveUserInfo(state, userInfo)
  {
    state.user = userInfo;
  },
  saveUserMenus(state,menus)
  {
    state.userMenus = menus;
  },
  saveUserRoutes(state,routes)
  {
    state.userRoutes = routes;
  }
};

const actions = {
  async getCurrentUserInfo({commit, state}, force = false)
  {
    if (!force && state.user)
      return state.user;
    const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;
    const info = await jwtInterceptor.get(apiUrl + 'auth/admin/getFullInfo');
    if (info && info.data && info.data.user)
    {
      commit('saveUserInfo', info.data.user);
    }
  },
  async loadStorageTokens({commit})
  {
    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");
    if (access_token && refresh_token)
    {
      const tokenData = {
        access_token: access_token,
        refresh_token: refresh_token,
      };
      commit("saveAuthToken", tokenData);
    }
  },
  async loginUser({commit},data)
  {
    // const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + 'user/login';
    // const response = await axios.post(url, payload, {
    //   headers: {
    //     'Access-Control-Allow-Origin': '*'
    //   }
    // });
    // if (response.status === 200 && response.data && response.data.ok)
    // {
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);

      const authResultData = {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        userId : data.userId
      }
      commit("saveAuthToken", authResultData);
      commit('saveUserInfo', data.user);
      commit("saveLoginStatus", "success");

      return authResultData;
    // }
    // else
    // {
    //   commit("saveLoginStatus", "failed");
    //   return response.data;
    // }
  },
  async logoutUser({commit})
  {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    commit("removeAuthToken");
    commit('saveUserInfo', null)
  },
  getUserMenus({commit, state})
  {
    console.log(state.userMenus)
    if (state.userMenus && state.userMenus.length)
    {
      return state.userMenus;
    }
    const user = state.user;
    if (user)
    {
      if (user.user_role === 'visitor')
      {
        commit('saveUserMenus', visitorMenus);
        // commit('saveUserRoutes', visitorRoutes);
        return visitorRoutes;
      }
      else
      {
        commit('saveUserMenus', admin_menus);
        // commit('saveUserRoutes', adminRoutes);
        return adminRoutes;
      }
    }
  }
};

const getters = {
  getLoginStatus(state)
  {
    return state.loginStatus;
  },
  getUserInfo(state)
  {
    return state.user;
  },
  getAuthData(state)
  {
    return state.authData;
  },
  getMenus(state)
  {
    return state.userMenus;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};